.gameIsOnHeader {
  padding: 16px;
  background: linear-gradient(135deg, #ffedca, #c09e55);
  color: black;
  font-size: 20px;
}
